module.exports = __webpack_public_path__ + "img/icon-remove-outline.ef28dcd9.svg";